import api from '../../api';
import GlobalVariable from '../../GlobalVariable';

export type LearningStatus = 'new' | 'opened' | 'in_progress' | 'retry' | 'passed';

export type LearningLesson = {
    id: number;
    categoryId: number;
    title: string;
    image: string | null;
    duration: string | null;
    questionCount: number;
    rewardCoins: number | null;
    status: LearningStatus;
};

export type LearningCategory = {
    id: number;
    title: string;
    lessonCount: number;
    testCount: number;
    passedCount: number;
    lessons: LearningLesson[];
};

export type LearningOverview = {
    categories: LearningCategory[];
    continueLesson: LearningLesson | null;
    progress: {passedTests: number; totalTests: number};
};

export const learningLessonUrl = (lesson: LearningLesson) =>
    `/knowledge-base/${lesson.categoryId}/lesson/${lesson.id}`;

export const learningCount = (count: number, one: string, few: string, many: string) => {
    const remainder = count % 100;
    const last = count % 10;
    const word = remainder >= 11 && remainder <= 14 ? many : last === 1 ? one : last >= 2 && last <= 4 ? few : many;
    return `${count} ${word}`;
};

export const learningStatusLabel = (status: LearningStatus) => ({
    new: 'Новый',
    opened: 'Урок открыт',
    in_progress: 'Тест в процессе',
    retry: 'Повторить тест',
    passed: 'Тест пройден',
})[status];

export const loadLearningOverview = async (): Promise<LearningOverview> => {
    const response = await api.get(GlobalVariable.staffBack() + '/api/staff/learning/overview', {
        withCredentials: true,
    });
    return response.data;
};
